import {
  AccountInfo,
  AuthenticationResult,
  INavigationClient,
  IPublicClientApplication,
  Logger,
  SilentRequest,
  WrapperSKU,
} from '@azure/msal-browser';

const mockAccount = {
  name: 'Test User',
  username: 'test_user',
} as AccountInfo;

const MsalBrowserMock = {
  getLogger: (): Logger => new Logger({}),
  getAllAccounts: (): AccountInfo[] => [mockAccount],
  getActiveAccount: (): AccountInfo | null => mockAccount,
  setActiveAccount: (_account: AccountInfo | null): void => undefined,
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  addEventCallback: (_: () => Function): string | null => null,
  initializeWrapperLibrary: (_sku: WrapperSKU, _version: string) => {}, // eslint-disable-line @typescript-eslint/no-empty-function
  initialize: (): Promise<void> => Promise.resolve(),
  handleRedirectPromise: (_: string): Promise<AuthenticationResult | null> => Promise.resolve(null),
  setNavigationClient: (_: INavigationClient): void => undefined,
  acquireTokenSilent: (_: SilentRequest): Promise<AuthenticationResult> =>
    Promise.resolve({ accessToken: 'test-access-token' } as AuthenticationResult),
} as IPublicClientApplication;

export default MsalBrowserMock;
